module.exports = __webpack_public_path__ + "files/df3e6a57799dd81ff74425b6b4001354.svg";